module.exports = __webpack_public_path__ + "./fonts/UbuntuMono-Regular.ttf";